/**
 * Quick Add functionality for featured product cards in cart drawer
 * Adds the card's displayed variant directly to cart
 */

document.addEventListener('DOMContentLoaded', function() {
  // Handle quick-add buttons for featured products
  document.addEventListener('click', function(e) {
    const addBtn = e.target.closest('.quick-add-featured');
    if (!addBtn) return;

    e.preventDefault();

    const variantId = addBtn.dataset.variantId;
    const productHandle = addBtn.dataset.productHandle;

    if (!variantId) {
      console.error('No variant ID found');
      return;
    }

    // Prevent double clicks while an add is in flight
    if (addBtn.disabled) return;

    // Add loading state
    addBtn.disabled = true;
    addBtn.style.opacity = '0.6';
    const originalContent = addBtn.innerHTML;
    addBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="6" stroke="currentColor" stroke-width="2" stroke-dasharray="4" opacity="0.3"/></svg>';

    // Add to cart
    fetch(window.theme.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1
        }]
      })
    })
    .then(response => response.json().then(data => {
      if (!response.ok) {
        // A sold-out / inventory-cap add returns 422 with a valid JSON body —
        // it parses fine, so we must gate on response.ok or it hits success.
        // Shopify puts the human message in `description`.
        throw new Error(data.description || data.message || 'Add to cart failed');
      }
      return data;
    }))
    .then(data => {
      // Success! Refresh cart using centralized function
      if (typeof window.refreshCart === 'function') {
        window.refreshCart();
      } else {
        console.warn('window.refreshCart not available, falling back to old method');
        refreshCartDrawerComplete();
      }

      // Show brief success state with animation
      addBtn.classList.add('success');
      addBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 4L6 11L3 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      setTimeout(() => {
        addBtn.classList.remove('success');
        addBtn.innerHTML = originalContent;
        addBtn.style.opacity = '1';
        addBtn.disabled = false;
      }, 1200);
    })
    .catch(error => {
      console.error('Error adding to cart:', error.message || error);

      // Failed add (422 / network) — show a brief error state. Do NOT refresh
      // the cart: nothing was added and the drawer is already open.
      addBtn.classList.add('error');
      addBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 4L12 12M12 4L4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      setTimeout(() => {
        addBtn.classList.remove('error');
        addBtn.innerHTML = originalContent;
        addBtn.style.opacity = '1';
        addBtn.disabled = false;
      }, 1200);
    });
  });
});

/**
 * Refresh cart drawer with updated content (Legacy fallback)
 * NOTE: Use window.refreshCart() from cart-refresh.js instead
 */
function refreshCartDrawerComplete() {
  const sections = 'cart-drawer,cart-bubble';

  fetch(`${window.location.pathname}?sections=${sections}`)
    .then(response => response.json())
    .then(data => {
      // Update cart drawer
      if (data['cart-drawer']) {
        const cartDrawer = document.getElementById('Cart-Drawer');
        if (cartDrawer) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(data['cart-drawer'], 'text/html');
          const newInner = doc.querySelector('.side-panel-inner');
          const currentInner = cartDrawer.querySelector('.side-panel-inner');

          if (newInner && currentInner) {
            currentInner.replaceWith(newInner);
          } else {
            console.error('Could not find drawer elements');
          }
        }
      }

      // Update cart bubble
      if (data['cart-bubble']) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data['cart-bubble'], 'text/html');
        const newBubble = doc.querySelector('.thb-item-count');
        const currentBubble = document.querySelector('.thb-item-count');

        if (newBubble && currentBubble) {
          currentBubble.replaceWith(newBubble);
        }
      }

      // Note: Progress bar not updated in legacy method
      // Use window.refreshCart() instead for proper updates
    })
    .catch(error => {
      console.error('Error refreshing cart drawer:', error);
    });
}

// Utility function to dispatch custom events
function dispatchCustomEvent(eventName, detail = {}) {
  const event = new CustomEvent(eventName, {
    bubbles: true,
    detail: detail
  });
  document.dispatchEvent(event);
}
